import type { GroupItem, ItemGroup } from '../../../../../types/templates';

import { ESPN_HERO_LEAGUES } from '../data/leagues';
import { getPlayerImageUrl } from '../urls';

export const loadSubImages = (item: GroupItem, group: ItemGroup, league: string): Promise<string[]> => {
  const leagueData = ESPN_HERO_LEAGUES.find(l => l.value === league);
  const team = leagueData?.teams.find(t => t.value === group.id);
  const player = team?.players.find(p => p.value === item.value);
  const filenames = player?.images ?? [];
  const urls = filenames.map(filename => getPlayerImageUrl(league, group.id, item.value, filename));
  return Promise.resolve(urls);
};
